import React from 'react';
import './BestRateBlock.scss';
import RateOption from './RateOption';
import InfoMessage from './InfoMessage';
import { formatCurrency, formatDate } from "../../../utils/helpers";

/** @import {BestRatesBlockProps} from './BestRateBlockTypes' */
const rateOptions = [
    {
        title: '1-Year Fixed Rate Saver',
        rate: '4.80%',
        oldrate: '4.85%'
    },
    {
        title: '2-Year Fixed Rate Saver',
        rate: '5.03%',
        oldrate: '4.95%'
    },
    {
        title: '3-Year Fixed Rate Saver',
        rate: '5.05%',
        oldrate: '5.01%'
    }
    ,{
        title: '4-Year Fixed Rate Saver',
        rate: '6.05%',
        oldrate: '6.01%'
    }
];

function BestRatesBlock(/** @type {BestRatesBlockProps} */ { maturingAccount, products }) {
    return (
        <div className="bestRatesBlock">
            <div className="bestRatesBlock_container">
                <div className="content">
                    <span className="title_content">Here are your renewal rate options</span>
                    <div className="optionsContainer">
                        <div className="optionsWrapper">
                            {/*{rateOptions.map((option, index) => (*/}
                            {/*    <RateOption key={index} {...option} />*/}
                            {/*))}*/}
                            {products.map((option, index) => (
                                <RateOption
                                    key={index}
                                    {...option}
                                    oldrate={maturingAccount == undefined ? 0 : (maturingAccount.maturity == undefined ? 0 : maturingAccount.maturity.availableRolloverRates.filter(p => p.productId == option.id)[0].rate)} />
                            ))}

                        </div>
                        <InfoMessage
                            maturingAccount={maturingAccount == undefined ? undefined : maturingAccount}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default BestRatesBlock;